import React, { useRef } from 'react'; import axios from 'axios' ;
import ContentHeader from '../../../content/ContentHeader'; import { useState, useEffect} from 'react';
import Cookies from 'universal-cookie'; 
import Swal from 'sweetalert2'; import withReactContent from 'sweetalert2-react-content';
import BootstrapTable from 'react-bootstrap-table-next'
import {Search as NoirSearch, Trash } from 'iconoir-react'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useNavigate } from 'react-router-dom';

import { Tooltip } from 'react-tooltip';
import SwitchOnOff from '../configTicket/SwitchOnOff';
import useOrientation from '../../../general/useOrientation';

const cookies = new Cookies();
const MySwal = withReactContent(Swal)
const { SearchBar } = Search;

function ConfigTenantTable({link, refresh, setLoading, clickLink, filterData,parentOrCat}) {
  const clickedColumnIndex = useRef();
  const navigate = useNavigate();
  const displayedRow = 12;
  const [dataa, setDataa] = useState([]);
  const [totlength, setTotLength] = useState(0);
  const [txtBL, setTxtBL] = useState('');
  const [currentPage, setCurrentPage] = useState(0); // Track the current page
  const tableRef = useRef();
  const lastRequest = useRef(0); // nomor permintaan data terakhir, lihat getData
  const [searchTick, setSearchTick] = useState(0); // naik tiap hasil search/data berubah -> sel nomor digambar ulang
  var sessionData = cookies.get('sessionData', { path: '/' })
  const orientation = useOrientation();
  let isThisPortrait = false;
  if (orientation === 'portrait') { isThisPortrait = true;}
  useEffect(() => {
    setLoading(true)
    if (filterData.length > 0){
      //getFilteredData(link)
    } else {
      getData(link);
    }
  }, [link,filterData])

  useEffect(() => {
    if (filterData.length > 0){
      //getFilteredData(link)
    } else {
      getData(link);
    }
  }, [refresh])

  useEffect(() => {
    let cpmone = parseInt(currentPage) - 1 
    let firstDigit = (parseInt(displayedRow) * parseInt(cpmone) )
    let secondDigit = parseInt(firstDigit) + parseInt(displayedRow)
    if (secondDigit > totlength) secondDigit = totlength
    let a = `${firstDigit+1} - ${secondDigit} of ${totlength} data`   ;
    setTxtBL(a);
    if (totlength === 0){
      setTxtBL();
    }
  }, [currentPage,totlength])
  
  // Simpan hasil toggle ke data tabel: baris yang di-mount ulang (ganti halaman / search) membaca nilai dari sini,
  // jadi tidak kembali menampilkan status lama sampai halaman di-refresh.
  const updateActive = (id, val) => {
    setDataa(prev => prev.map(r => r.id === id ? { ...r, active: val } : r));
  }

  // Hapus dari UI saja (soft delete): hanya baris yang sudah OFF; datanya tetap di DB (deleted_at/deleted_by).
  const deleteRow = (row, canDelete) => {
    if (!canDelete) {
      MySwal.fire({
        title: <strong>Belum bisa dihapus</strong>,
        html: <p>Matikan statusnya (OFF) dulu, baru bisa dihapus dari daftar.</p>,
        icon: 'info',
      })
      return;
    }
    const name = parentOrCat === 'cat' ? `${row.display_name || row.nama_user || row.email}${row.nama_tenant ? ' - ' + row.nama_tenant : ''}`
      : parentOrCat === 'rr' ? `${row.nama}${row.blok ? ' (' + row.blok + ')' : ''}`
      : row.nama_tenant;
    MySwal.fire({
      title: <strong>Hapus dari daftar?</strong>,
      html: <p><b>{name}</b> akan hilang dari daftar ini. Datanya tetap tersimpan di database dan bisa dikembalikan.</p>,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: 'Batal',
      confirmButtonText: 'Hapus',
    }).then(result => {
      if (!result.isConfirmed) return;
      setLoading(true);
      var sessionToken = cookies.get('sessionToken', { path: '/' })
      const config = { headers: { 'x-access-token': sessionToken } };
      axios.post(`${process.env.REACT_APP_PATH_DESTINATION}/${link}/delete/${row.id}`, {}, config)
        .then(res => {
          setLoading(false);
          if (res.data.status !== '200') {
            MySwal.fire({
              title: <strong>Error!</strong>,
              html: <p>Gagal menghapus. Pastikan statusnya sudah OFF, lalu refresh halaman.</p>
            })
            return;
          }
          setDataa(prev => prev.filter(r => r.id !== row.id));
          setTotLength(prev => prev - 1);
        })
        .catch(err => {
          console.log(err);
          MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
          })
          setLoading(false);
        })
    })
  }

  // Proporsi kolom (layar lebar) mengikuti contoh tabel dari Tobby; di HP dibiarkan otomatis.
  const colWidth = (w) => () => (isThisPortrait ? {} : { width: w });
  const indexHeaderStyle = () => (isThisPortrait ? { width: '80px' } : { width: '4%' }); // Adjust the width of the index column
  const statusHeaderStyle = colWidth('10.5%');
  const showOrDash = (cell) => (cell === null || cell === undefined || String(cell).trim() === '' ? '-' : cell);

  // Tanda arah sort di samping judul kolom yang sedang dipakai (CSS caret bawaan library tidak dimuat di Helpdesk).
  // asc = ▲, desc = ▼; kolom yang tidak sedang di-sort tidak menampilkan apa-apa.
  const sortCaret = (order) => {
    if (!order) return null;
    return <span style={{ color: '#0296D2', marginLeft: '6px', fontSize: '12px' }}>{order === 'asc' ? '▲' : '▼'}</span>;
  };
  // Sesudah sort, kembali ke halaman 1 (bawaan library: tetap di halaman yang sedang dibuka, jadi sort dari
  // halaman 5 menampilkan baris ke-49 dst. dan terlihat tidak urut). Ditunda sebentar supaya berjalan sesudah
  // library selesai memproses sort.
  const backToFirstPage = () => Promise.resolve().then(() => {
    const pagination = tableRef.current?.paginationContext;
    if (pagination && pagination.currPage !== 1) {
      pagination.handleChangePage(1);
      // Gambar ulang sel nomor: baris yang kebetulan ada di posisi yang sama (mis. baris pertama hal. 4 jadi
      // baris pertama hal. 1) tidak digambar ulang oleh library dan masih memakai nomor halaman lama.
      setSearchTick(t => t + 1);
    }
  });
  const withSorting = (cols) => cols.map(c => (c.sort ? { ...c, sortCaret, onSort: backToFirstPage } : c));

  // Urutan awal: nama perusahaan A-Z tanpa melihat awalan badan usaha (PT, PT., CV), jadi "PT. Bank X" berdekatan
  // dengan "PT Bank Y" dan nama tanpa PT ikut urut di hurufnya. Nama yang tampil tidak berubah.
  const namaInti = (s) => String(s || '').trim().replace(/^(PT|CV)\b\.?\s*/i, '');
  const bandingNama = (a, b) => a.localeCompare(b, 'id', { sensitivity: 'base' });
  const sortNamaPerusahaan = (field2) => (a, b, order, dataField, rowA, rowB) => {
    const r = bandingNama(namaInti(a), namaInti(b)) || bandingNama(String(a || ''), String(b || ''))
      || bandingNama(String(rowA[field2] || ''), String(rowB[field2] || '')); // nama sama: urut kolom kedua
    return order === 'asc' ? r : -r;
  };
  const defaultSorted = [{ dataField: parentOrCat === 'rr' ? 'nama' : 'nama_tenant', order: 'asc' }];

  // Nomor urut nyambung antar halaman (hal. 2 mulai dari 13). Halaman aktif dibaca langsung dari paginator tabel,
  // jadi tetap benar saat search / hapus menggeser halaman.
  const rowNumber = (cell, row, rowIndex) => {
    const page = tableRef.current?.paginationContext?.currPage || 1;
    return (page - 1) * displayedRow + rowIndex + 1;
  }

  const activeFormatter = (data,row) => {
    const canDelete = Number(row.active) === 0;
    return (
      <div style={{display:'flex', alignItems:'center', gap: isThisPortrait ? '3vw' : '2vw'}}>
        <SwitchOnOff setLoading={setLoading} link={link} initialActive={data} data={row.id} onChanged={(val) => updateActive(row.id, val)}/>
        <span
          title={canDelete ? 'Hapus dari daftar' : 'Matikan (OFF) dulu untuk bisa menghapus'}
          style={{display:'inline-flex', cursor:'pointer'}}
          onClick={() => deleteRow(row, canDelete)}
        >
          <Trash style={{color: '#FF553B', height: isThisPortrait ? '2vh' : '1.25vw', width: 'auto'}}/>
        </span>
      </div>
    )
  }

  const getData = (link) => {
    // Tiap permintaan diberi nomor dan hanya jawaban permintaan terakhir yang dipakai: jawaban lama yang datang
    // terlambat (mis. sesudah pindah tab) dibuang, supaya tidak menimpa isi tab yang sedang dibuka.
    const requestNo = ++lastRequest.current;
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    axios.interceptors.request.use(config => {config.headers['x-access-token'] = sessionToken;return config;},error => {return Promise.reject(error);});
    axios.get(`${process.env.REACT_APP_PATH_DESTINATION}/${link}`) 
      .then(res => {
        if (requestNo !== lastRequest.current) return;
        console.log(res.data.data);
        // Baris yang sudah dihapus dari UI (deleted_at terisi) tidak ditampilkan; datanya tetap di DB.
        const rows = (res.data.data || []).filter(r => !r.deleted_at);
        setDataa(rows);
        setTotLength(rows.length);
        setCurrentPage(1);
        setLoading(false);
      })
      .catch(err => {
        if (requestNo !== lastRequest.current) return;
        console.log(err);
            MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
        })
        setLoading(false);
      })
  }

  const getFilteredData = (link) => {
    console.log("logging filter data before hit API",filterData)
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    axios.interceptors.request.use(config => {config.headers['x-access-token'] = sessionToken;return config;},error => {return Promise.reject(error);});
    axios.post(`${process.env.REACT_APP_PATH_DESTINATION}/${link}`, { data: filterData }) 
      .then(res => {
        console.log("getfiltered data logging",res.data.data);
        setDataa(res.data.data[0]);
        setTotLength(res.data.data.length);
        setCurrentPage(1);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
            MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
        })
        setLoading(false);
      })
  }
  const options = {
    sortIndicator: true,
    bordered: false,
    hideSizePerPage: true, // Hide the option to change the number of rows
    sizePerPage: displayedRow, // You can set your desired default value here
    page: 1,
    showTotal: false, // Hide the total number of rows
    sizePerPageList: [] // Remove the size per page options from the dropdown
  };
  const handlePageChange = (type, { page, sizePerPage }) => {
    setCurrentPage(type); 
  };
  const searchProps = {
    placeholder:isThisPortrait? "search..." :"search config...",
    className: "searchRight",
    zIndex : 5,
    position: 'relative',
    height: '40px',
    fontFamily: 'Blender Pro !important'
  };

  const columnsParent = [
    {
      text: '#',
      dataField: 'index',
      sort: false, // nomor dihitung dari posisi baris, bukan data: tidak ada yang bisa diurutkan
      formatter: rowNumber,
      formatExtraData: searchTick,
      headerStyle: indexHeaderStyle,
      style: { color: '#8B9099' },
    },
    {
      text: 'Nama PT',
      dataField: 'nama_tenant',
      sort: true,
      sortFunc: sortNamaPerusahaan('blok_id'),
    },
    {
      text: 'Alamat PT',
      dataField: 'alamat_tenant',
      sort: true
    },
    {
      text: 'Block PT',
      dataField: 'blok_id',
      sort: true
    },
    {
      text: 'Status',
      dataField: 'active',
      sort:true,
      formatter:activeFormatter,
      headerStyle: statusHeaderStyle,
      events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
              clickedColumnIndex.current = columnIndex;
          },
      },
    }
  ];

  const columnsCat = [
    {
      text: '#',
      dataField: 'index',
      sort: false, // nomor dihitung dari posisi baris, bukan data: tidak ada yang bisa diurutkan
      formatter: rowNumber,
      formatExtraData: searchTick,
      headerStyle: indexHeaderStyle,
      style: { color: '#8B9099' },
    },
    {
      text: 'Tenant Name',
      dataField: 'nama_tenant',
      sort: true,
      sortFunc: sortNamaPerusahaan('display_name'),
    },
    {
      text: 'PIC Display Name',
      dataField: 'display_name',
      sort:true
    },
    {
      text: 'PIC Ext Position',
      dataField: 'dept_pic',
      sort:true
    },
    {
      text: 'PIC For Dept',
      dataField: 'tipe_pic',
      sort:true
    },
    {
      text: 'Email',
      dataField: 'email',
      sort:true
    },
    {
      text: 'Handphone',
      dataField: 'no_hp',
      sort:true
    },
    {
      text: 'Status',
      dataField: 'active',
      sort:true,
      formatter:activeFormatter,
      headerStyle: statusHeaderStyle,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
            clickedColumnIndex.current = columnIndex;
        },
      },
    }
  ];

  const columnsRR = [
    {
      text: '#',
      dataField: 'index',
      sort: false, // nomor dihitung dari posisi baris, bukan data: tidak ada yang bisa diurutkan
      formatter: rowNumber,
      formatExtraData: searchTick,
      headerStyle: indexHeaderStyle,
      style: { color: '#8B9099' },
    },
    {
      text: 'Tenant Name',
      dataField: 'nama',
      sort: true,
      sortFunc: sortNamaPerusahaan('blok'),
      headerStyle: colWidth('26%'),
    },
    {
      text: 'Entitas',
      dataField: 'entitas',
      sort:true,
      headerStyle: colWidth('7%'),
    },
    {
      text: 'Alamat',
      dataField: 'alamat',
      sort:true,
      headerStyle: colWidth('21%'),
    },
    {
      text: 'Blok',
      dataField: 'blok',
      sort:true,
      headerStyle: colWidth('10%'),
    },
    {
      text: 'Status Doc',
      dataField: 'doc_status',
      sort:true,
      headerStyle: colWidth('12.5%'),
    },
    {
      text: 'Tahun Doc',
      dataField: 'doc_year',
      sort:true,
      headerStyle: colWidth('9%'),
      headerAlign: 'center',
      align: 'center',
      formatter: showOrDash,
    },
    {
      text: 'Status',
      dataField: 'active',
      sort:true,
      formatter:activeFormatter,
      headerStyle: statusHeaderStyle,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
            clickedColumnIndex.current = columnIndex;
        },
      },
    }
  ];

  const tableRowEvents = {
    onClick: (e, row, rowIndex) => {
      if ((parentOrCat == "cat" || parentOrCat == "rr") && clickedColumnIndex.current === 7) {
        // Do nothing - kolom toggle Status (Tenant User & RKL RPL sama-sama index 7)
      } else if (parentOrCat == "parent" && clickedColumnIndex.current === 4){
        //do nothing as well
      } else {
        //navigate(clickLink+row.id,'_blank');
        window.open(clickLink + row.id, '_blank');
      }
      // Reset clickedColumnIndex
      clickedColumnIndex.current = undefined;
    },
    onMouseEnter: (e, row, rowIndex) => {
      //console.log(`enter on row with index: ${rowIndex}`);
    }
  }
  return (
    <>
    <ContentHeader title=""/> 
        <section className="content">
        <div className="container-fluid">
            <div className="row"> 
              <div className="col-md-12">
                {/* key={link}: ganti tab = tabel baru mulai dari halaman 1, jadi nomor & teks "x - y of N data" tetap sejalan */}
                <ToolkitProvider
                  key={link}
                  keyField="id"
                  data={dataa}
                  columns={withSorting(parentOrCat === 'cat' ? columnsCat : parentOrCat === 'rr' ? columnsRR : columnsParent)}
                  bootstrap4={true}
                  search={{ ...searchProps, afterSearch: () => setSearchTick(t => t + 1) }}
                >
                  {props => (
                    <div >
                      <div style={{ width:isThisPortrait? '25vw':'200px', float:'right',zIndex:-1 }}>          
                      <table>
                        <tbody>
                          <tr>
                          <td>
                            <SearchBar {...props.searchProps} {...searchProps} />
                          </td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                      <BootstrapTable
                        ref={tableRef}
                        {...props.baseProps}
                        defaultSorted={defaultSorted}
                        striped 
                        hover
                        pagination={paginationFactory({ ...options, onPageChange: handlePageChange })}
                        classes="custom-table" 
                        rowClasses="custom-row"
                        rowEvents={ tableRowEvents }
                      />
                    </div>
                  )}
                </ToolkitProvider>
                <div style={{marginTop:'1vw', marginLeft:isThisPortrait?'2vw':''}}>{txtBL}</div>
              </div>
            </div>
        </div>
     </section>
    </>

  )
}

export default ConfigTenantTable